import * as React from 'react'
import classNames from 'classnames'

import CloseThinIcon from 'ui-component-library/icons/close-thin.svg'
import MenuIcon from 'ui-component-library/icons/menu-mobile.svg'

import { LinkMenus } from './Menu'

import Menu from './Menu'

import style from './style.scss'

type Props = {
  'aria-label'?: string
  above?: React.ReactNode
  below?: React.ReactNode
  className?: string
  expanded?: boolean
  linkMenus: LinkMenus
  menuText: string
  onToggleExpanded: (arg0: boolean) => void
}

MobileMenu.defaultProps = {
  above: undefined,
  below: undefined,
  className: '',
  expanded: false,
}

function MobileMenu(props: Props) {
  const {
    above,
    'aria-label': ariaLabel,
    below,
    className,
    expanded,
    onToggleExpanded,
    linkMenus,
    menuText,
  } = props

  const menuProps = { className: style.menu, below, linkMenus }

  return (
    <nav
      aria-label={ariaLabel}
      className={classNames(
        style.wrapper,
        {
          [style.expanded]: expanded,
        },
        className,
      )}
      data-testid='mobile-menu'
    >
      <button
        aria-expanded={expanded}
        className={style.menuButton}
        onClick={() => onToggleExpanded(true)}
      >
        {expanded ? (
          <CloseThinIcon className={style.closeIcon} />
        ) : (
          <MenuIcon className={style.menuIcon} />
        )}
        <span className={style.menuButtonText}>{menuText}</span>
      </button>
      <div className={style.menuWrapper}>
        {above && above}
        <Menu {...menuProps} handleMenuClose={() => onToggleExpanded(false)} />
      </div>
    </nav>
  )
}

export default MobileMenu
